export default __webpack_public_path__ + "a02d0780b59aa8566843ed3dd382466a.png";